import { render, staticRenderFns } from "./m-edit-instant-dialog.vue?vue&type=template&id=4a7641e9&scoped=true&"
import script from "./m-edit-instant-dialog.vue?vue&type=script&lang=js&"
export * from "./m-edit-instant-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7641e9",
  null
  
)

export default component.exports